import { createSelector } from "reselect"
import type { OutputSelector } from "reselect"

import keys from "../consts/headerDataKeys"
import translateSelector from "../services/intl/translateSelector"
import type Options from "../records/Options"

type State = {
  // @ts-expect-error: Flow to TS migration.
  options: Options
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  page: any // FIXME proper type,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  translations: any // FIXME make proper definitions and import 'em here
}

const getPage = (state: State) => state.page.get("name") // FIXME make selector in the appropriate file

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getTitle: OutputSelector<State, any, string> = createSelector(
  [translateSelector, getPage],
  (translate, page) => {
    // @ts-expect-error: Flow to TS migration.
    if (keys[page]) {
      // @ts-expect-error: Flow to TS migration.
      return translate(keys[page].title, { brandName: "Kiwi.com" })
    }

    return translate("common.easy_booking_with_skypicker")
  },
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getKeywords: OutputSelector<State, any, string> = createSelector(
  [translateSelector, getPage],
  (translate, page) => {
    // Fix this the next time the file is edited. (Flow to TS)
    // @ts-expect-error: Flow to TS migration.
    // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
    if (keys[page] && keys[page].keywords) {
      // @ts-expect-error: Flow to TS migration.
      return translate(keys[page].keywords)
    }

    return translate("common.easy_booking_with_skypicker")
  },
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getDescription: OutputSelector<State, any, string> = createSelector(
  [translateSelector, getPage],
  (translate, page) => {
    // @ts-expect-error: Flow to TS migration.
    if (keys[page]) {
      // @ts-expect-error: Flow to TS migration.
      return translate(keys[page].description, { oldBrand: "Skypicker" })
    }

    return translate("common.easy_booking_with_skypicker")
  },
)

// Fix this the next time the file is edited. (Flow to TS)
// @ts-expect-error: Flow to TS migration.
// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const getImageOG: OutputSelector<State, any, string | null | undefined> = createSelector(
  [getPage],
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
  (page) => keys[page] && keys[page].image_og,
)

// @ts-expect-error: Flow to TS migration.
export const getImageTwitter: OutputSelector<
  State,
  // Fix this the next time the file is edited. (Flow to TS)
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  any,
  string | null | undefined
  // Fix this the next time the file is edited. (Flow to TS)
  // @ts-expect-error: Flow to TS migration.
  // eslint-disable-next-line @typescript-eslint/prefer-optional-chain
> = createSelector([getPage], (page) => keys[page] && keys[page].image_twitter)
